import React, { MouseEventHandler, ReactNode } from "react"

import { useChatInfo, useSetChatInfo } from "@shared/contexts"

import LinkItem from "./LinkItem"

interface Props {
  title: string
  children: ReactNode
}

const ChatLock = ({ title, children }: Props) => {
  const { isChatLock } = useChatInfo()
  const setChatInfo = useSetChatInfo()

  const handleLockClick: MouseEventHandler<HTMLAnchorElement> = (e) => {
    e.preventDefault()
    setChatInfo({
      type: "CHANGE_CHAT_LOCK",
      isChatLock: !isChatLock,
    })
  }

  return (
    <LinkItem
      className="ty02"
      innerClassName={isChatLock ? "on" : ""}
      title={title}
      onClick={handleLockClick}
    >
      {children}
    </LinkItem>
  )
}

export default ChatLock
